"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Transition = exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _themeable = require("@instructure/ui-themeable/lib/themeable.js");

var _ms = require("@instructure/ui-utils/lib/ms.js");

var _testable = require("@instructure/ui-testable/lib/testable.js");

var _BaseTransition = require("./BaseTransition");

var _theme = _interopRequireDefault(require("./theme"));

var _dec, _dec2, _class, _class2, _temp;

var styles = {
  componentId: 'eJkkQ',
  template: function template(theme) {
    return "\n\n.eJkkQ_bGBk{transform:translateZ(0)}\n\n.eJkkQ_ddDm{transition:opacity ".concat(theme.duration || 'inherit', " ").concat(theme.timing || 'inherit', ",transform ").concat(theme.duration || 'inherit', " ").concat(theme.timing || 'inherit', "}\n\n.eJkkQ_cpZA,.eJkkQ_fTmM{opacity:0.01}\n\n.eJkkQ_bEpV,.eJkkQ_NoZX{opacity:1}\n\n.eJkkQ_fOgU{transition:opacity ").concat(theme.duration || 'inherit', " ").concat(theme.timing || 'inherit', ",transform ").concat(theme.duration || 'inherit', " ").concat(theme.timing || 'inherit', "}\n\n.eJkkQ_ZDum,.eJkkQ_fihg{opacity:0.01;transform:scale(0.01) translateZ(0)}\n\n.eJkkQ_eqrf,.eJkkQ_ftWB{opacity:1;transform:scale(1) translateZ(0)}\n\n.eJkkQ_dlJm,.eJkkQ_cPWt,.eJkkQ_bewW,.eJkkQ_bHhn{transition:opacity ").concat(theme.duration || 'inherit', " ").concat(theme.timing || 'inherit', ",transform ").concat(theme.duration || 'inherit', " ").concat(theme.timing || 'inherit', "}\n\n.eJkkQ_bOBe,.eJkkQ_eKZC,.eJkkQ_cusP,.eJkkQ_djUe{opacity:0.01}\n\n.eJkkQ_cusP,.eJkkQ_dWfS{transform:translate3d(100%,0,0)}\n\n.eJkkQ_eKZC,.eJkkQ_chud{transform:translate3d(-100%,0,0)}\n\n.eJkkQ_djUe,.eJkkQ_fDdb{transform:translate3d(0,-100%,0)}\n\n.eJkkQ_bOBe,.eJkkQ_cYey{transform:translate3d(0,100%,0)}\n\n.eJkkQ_diPG,.eJkkQ_fEMB,.eJkkQ_eOlt,.eJkkQ_fvoZ,.eJkkQ_bIuM,.eJkkQ_fyZW,.eJkkQ_cuyj,.eJkkQ_gaix{opacity:1;transform:translateZ(0)}");
  },
  'root': 'eJkkQ_bGBk',
  'fade': 'eJkkQ_ddDm',
  'fade--exited': 'eJkkQ_cpZA',
  'fade--exiting': 'eJkkQ_fTmM',
  'fade--entered': 'eJkkQ_bEpV',
  'fade--entering': 'eJkkQ_NoZX',
  'scale': 'eJkkQ_fOgU',
  'scale--exited': 'eJkkQ_ZDum',
  'scale--exiting': 'eJkkQ_fihg',
  'scale--entered': 'eJkkQ_eqrf',
  'scale--entering': 'eJkkQ_ftWB',
  'slide-down': 'eJkkQ_dlJm',
  'slide-left': 'eJkkQ_cPWt',
  'slide-right': 'eJkkQ_bewW',
  'slide-up': 'eJkkQ_bHhn',
  'slide-down--exited': 'eJkkQ_bOBe',
  'slide-left--exited': 'eJkkQ_eKZC',
  'slide-right--exited': 'eJkkQ_cusP',
  'slide-up--exited': 'eJkkQ_djUe',
  'slide-right--exiting': 'eJkkQ_dWfS',
  'slide-left--exiting': 'eJkkQ_chud',
  'slide-up--exiting': 'eJkkQ_fDdb',
  'slide-down--exiting': 'eJkkQ_cYey',
  'slide-down--entered': 'eJkkQ_diPG',
  'slide-down--entering': 'eJkkQ_fEMB',
  'slide-left--entered': 'eJkkQ_eOlt',
  'slide-left--entering': 'eJkkQ_fvoZ',
  'slide-right--entered': 'eJkkQ_bIuM',
  'slide-right--entering': 'eJkkQ_fyZW',
  'slide-up--entered': 'eJkkQ_cuyj',
  'slide-up--entering': 'eJkkQ_gaix'
};

/**
---
category: components/utilities
---
@module Transition
**/
var Transition = (_dec = (0, _testable.testable)(), _dec2 = (0, _themeable.themeable)(_theme.default, styles), _dec(_class = _dec2(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Transition, _Component);

  var _super = (0, _createSuper2.default)(Transition);

  function Transition() {
    var _this;

    (0, _classCallCheck2.default)(this, Transition);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.handleExited = function () {
      if (typeof _this.props.onExited === 'function') {
        _this.props.onExited(_this.props.type);
      }
    };

    _this.handleEntered = function () {
      if (typeof _this.props.onEntered === 'function') {
        _this.props.onEntered(_this.props.type);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(Transition, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          type = _this$props.type,
          children = _this$props.children,
          props = (0, _objectWithoutProperties2.default)(_this$props, ["type", "children"]);
      var duration = (0, _ms.ms)(this.theme.duration);
      var classNames = type ? {
        'exited': styles["".concat(type, "--exited")],
        'exiting': styles["".concat(type, "--exiting")],
        'entering': styles["".concat(type, "--entered")],
        'entered': styles["".concat(type, "--entering")]
      } : {};
      return /*#__PURE__*/_react.default.createElement(_BaseTransition.BaseTransition, Object.assign({}, props, {
        enterDelay: duration,
        exitDelay: duration,
        transitionClassName: styles[type],
        exitedClassName: classNames.exited,
        exitingClassName: classNames.exiting,
        enteredClassName: classNames.entering,
        enteringClassName: classNames.entered,
        onEntered: this.handleEntered,
        onExited: this.handleExited
      }), children);
    }
  }]);
  Transition.displayName = "Transition";
  return Transition;
}(_react.Component), _class2.propTypes = {
  type: _propTypes.default.oneOf(['fade', 'scale', 'slide-down', 'slide-up', 'slide-left', 'slide-right']),

  /**
   * A single element to animate in and out
   */
  children: _propTypes.default.element,

  /**
   * Show the component; triggers the enter or exit animation
   */
  in: _propTypes.default.bool,

  /**
   * Unmount the component (remove it from the DOM) when it is not shown
   */
  unmountOnExit: _propTypes.default.bool,

  /**
   * Run the enter animation when the component mounts, if it is initially
   * shown
   */
  transitionOnMount: _propTypes.default.bool,

  /**
   * Run the enter animation
   */
  transitionEnter: _propTypes.default.bool,

  /**
   * Run the exit animation
   */
  transitionExit: _propTypes.default.bool,

  /**
   * Callback fired when transitioning to the next state
   */
  onTransition: _propTypes.default.func,

  /**
   * Callback fired before the "entering" classes are applied
   */
  onEnter: _propTypes.default.func,

  /**
   * Callback fired after the "entering" classes are applied
   */
  onEntering: _propTypes.default.func,

  /**
   * Callback fired after the "enter" classes are applied
   */
  onEntered: _propTypes.default.func,

  /**
   * Callback fired before the "exiting" classes are applied
   */
  onExit: _propTypes.default.func,

  /**
   * Callback fired after the "exiting" classes are applied
   */
  onExiting: _propTypes.default.func,

  /**
   * Callback fired after the "exited" classes are applied
   */
  onExited: _propTypes.default.func
}, _class2.defaultProps = {
  type: 'fade',
  in: false,
  unmountOnExit: false,
  transitionOnMount: false,
  transitionEnter: true,
  transitionExit: true,
  onEnter: function onEnter() {},
  onEntering: function onEntering() {},
  onEntered: function onEntered() {},
  onExit: function onExit() {},
  onExiting: function onExiting() {},
  onExited: function onExited() {},
  onTransition: function onTransition(toState, fromState) {},
  children: null
}, _class2.states = _BaseTransition.BaseTransition.states, _temp)) || _class) || _class);
exports.Transition = Transition;
var _default = Transition;
exports.default = _default;